export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7973.000c425a.jpg";